const map = {
	"./archive/backup.bos.json": 6483,
	"./archive/backup.pbi.json": 7266,
	"./bos.json": 2884,
	"./djt.json": 6274,
	"./globals.json": 1808,
	"./lna.json": 3125,
	"./pbi.json": 7845,
	"./syd.json": 8224
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5391;